import { SET_CURRENT_PAGE, SET_SELECTED_CATEGORY } from "../action/actionTypes";

const initialState = {
  currentPage: 1,
  selectedCategory: "All",
};

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };

    case SET_SELECTED_CATEGORY:
      return {
        ...state,
        selectedCategory: action.payload,
      };

    default:
      return state;
  }
};

export default filterReducer;
